/*! @azure/msal-common v4.4.0 2021-06-29 */
'use strict';

import { __extends } from '../../_virtual/_tslib.js';
import { CredentialEntity } from './CredentialEntity.js';
import { CredentialType } from '../../utils/Constants.js';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

/**
 * REFRESH_TOKEN Cache
 *
 * Key:Value Schema:
 *
 * Key Example: uid.utid-login.microsoftonline.com-refreshtoken-clientId--
 *
 * Value:
 * {
 *      homeAccountId: home account identifier for the auth scheme,
 *      environment: entity that issued the token, represented as a full host
 *      credentialType: Type of credential as a string, can be one of the following: RefreshToken, AccessToken, IdToken, Password, Cookie, Certificate, Other
 *      clientId: client ID of the application
 *      secret: Actual credential as a string
 *      familyId: Family ID identifier, '1' represents Microsoft Family
 *      realm: Full tenant or organizational identifier that the account belongs to
 *      target: Permissions that are included in the token, or for refresh tokens, the resource identifier.
 * }
 */

var RefreshTokenEntity = function (_super) {
  __extends(RefreshTokenEntity, _super);

  function RefreshTokenEntity() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   * Create RefreshTokenEntity
   * @param homeAccountId
   * @param authenticationResult
   * @param clientId
   * @param authority
   */


  RefreshTokenEntity.createRefreshTokenEntity = function (homeAccountId, environment, refreshToken, clientId, familyId, oboAssertion) {
    var rtEntity = new RefreshTokenEntity();
    rtEntity.clientId = clientId;
    rtEntity.credentialType = CredentialType.REFRESH_TOKEN;
    rtEntity.environment = environment;
    rtEntity.homeAccountId = homeAccountId;
    rtEntity.secret = refreshToken;
    rtEntity.oboAssertion = oboAssertion;
    if (familyId) rtEntity.familyId = familyId;
    return rtEntity;
  };
  /**
   * Validates an entity: checks for all expected params
   * @param entity
   */


  RefreshTokenEntity.isRefreshTokenEntity = function (entity) {
    if (!entity) {
      return false;
    }

    return entity.hasOwnProperty("homeAccountId") && entity.hasOwnProperty("environment") && entity.hasOwnProperty("credentialType") && entity.hasOwnProperty("clientId") && entity.hasOwnProperty("secret") && entity["credentialType"] === CredentialType.REFRESH_TOKEN;
  };

  return RefreshTokenEntity;
}(CredentialEntity);

export { RefreshTokenEntity };